<template>
  <div class="">
    <Backtester
      v-if="$root.advisor.hasFeature('Backtester') && portfolio.holdings.length"
      :universe="portfolio"
      :screens="screens.a"
      isInPortfolioEditor
    />
    <div class="halfBottomMargin">
      <!-- <b-input v-model="portfolio.name"/> -->
      <TypeaheadPortfolioSearch :callback="portfolioSelectedCallback"/>
    </div>

    <Flex class="heavy blackText topMargin2 bottomMargin2">{{ portfolio.name }}</Flex>
    <Flex class="halfBottomMargin" v-if="hasWorkingPortfolio">
      <div class="base1 slightCurvedBorder pointer rightMargin rightPadding"
        :style="{ backgroundColor: 'rgba(128, 94, 230, 0.2)' }"
        @click="savePortfolio"
      >
        <p class="base1Text heavy leftMargin topBottomHalfMargin fontSizeThreeQuarters inlineBlockDisplay">
          Save portfolio
        </p>
      </div>
      <Flex class="mainAxisFlexEnd crossAxisCenter redText heavy fontSizeThreeQuarters">
        <div class="pointer" @click="clear">
          Reset
        </div>
      </Flex>
    </Flex>
    <Flex v-else class="halfBottomMargin" >
      <div class="grayText">
        Choose an existing portfolio to start, or just add holdings from the results on the left
      </div>
    </Flex>
    <div class="bottomMargin25Px" v-for="(value, key) in chartData2()" :key="key">
      <div :class="`fontSizeHalf ${value.label === 'Overall Alignment' ? 'extraBold' : 'heavy'}`">{{value.label}}</div>
      <div class="relativePosition">
        <div class="height20Px fullWidth absolutePosition slightCurvedBorder" :style="{ backgroundColor: '#eeeff2' }" />
        <div
          class="height20Px lineHeight17Px fontSizeHalf leftPaddingHalf bold width150Px base1 absolutePosition leftSlightCurvedBorder"
          :style="{
            width: `${value.score * 10}%`,
            backgroundColor: value.color,
            borderRadius: value.score > '9.8' ? '5px' : '',
            color: textColorScale()(value.score),
          }"
        >{{Number(value.score).toFixed()}}</div>
      </div>
    </div>
    <a v-if="portfolio.destination.id" :href="reportUrl" target="_blank" rel="noreferrer noopener">
      <div class="base1 allAroundPadding centerText largeCurvedBorder whiteText heavy topMarginHalf topMargin3 pointer">
        Generate a report
      </div>
    </a>
    <Flex  v-show="portfolio.destination.status != 'd'" class="fullWidth topMargin centerCenter">
      <IRebalSync v-bind:modelPortfolioId="portfolio.destination.id" v-show="$root.advisor.hasFeature('iRebal Integration')"/>
    </Flex>

    <Flex class="heavy blackText topMargin4">Portfolio Holdings:</Flex>
    <div class="topMargin">
      <Flex v-for="(holding, index) in portfolio.holdings" :key="index" class="bottomMargin2 topBlackBorder flexColumn">
        <Flex class="topMargin2">
          <Flex class="flex4 flexColumn">
            <Flex class="heavy blackText">
              {{holding.symbol}}
            </Flex>
            <Flex class="fontSizeHalf grayText">
              {{holding.full_name}}
            </Flex>
            <Flex class="fontSizeHalf">
              {{holding.benchmark_description}}
            </Flex>
          </Flex>
          <Flex class="mainAxisFlexEnd" v-if="chartData2(screenedHoldingsById[holding.id]).overall">
            <div class="flex1 square32Px slightCurvedBorder centerCenter" :style="{
                  backgroundColor: chartData2(screenedHoldingsById[holding.id]).overall.color,
                  color: textColorScale()(chartData2(screenedHoldingsById[holding.id]).overall.score),
                }">
              <p class="heavy">
               {{chartData2(screenedHoldingsById[holding.id]).overall.score.toFixed()}}
              </p>
            </div>
          </Flex>
        </Flex>
        <Flex class="topMargin">
          <Flex>
            <div class="base1 slightCurvedBorder pointer rightMargin rightPadding leftPadding"
              @click="exchangeHolding(holding)"
              :style="{ backgroundColor: 'rgba(128, 94, 230, 0.2)' }"
            >
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.75 4.125H9.44062L8.09578 5.46984C7.80281 5.76281 7.80281 6.23742 8.09578 6.53039C8.24063 6.67734 8.43281 6.75 8.625 6.75C8.81719 6.75 9.00891 6.67676 9.15516 6.53027L11.7802 3.90527C12.0731 3.6123 12.0731 3.1377 11.7802 2.84473L9.15516 0.219727C8.86219 -0.0732422 8.38758 -0.0732422 8.09461 0.219727C7.80164 0.512695 7.80164 0.987305 8.09461 1.28027L9.44062 2.625H0.75C0.335391 2.625 0 2.96039 0 3.375C0 3.78961 0.335391 4.125 0.75 4.125ZM11.25 7.875H2.56172L3.90656 6.53016C4.19953 6.23719 4.19953 5.76258 3.90656 5.46961C3.61359 5.17664 3.13898 5.17664 2.84602 5.46961L0.221016 8.09461C-0.0719531 8.38758 -0.0719531 8.86219 0.221016 9.15516L2.84602 11.7802C2.99062 11.9273 3.18281 12 3.375 12C3.56719 12 3.75891 11.9268 3.90516 11.7803C4.19812 11.4873 4.19812 11.0127 3.90516 10.7197L2.56172 9.375H11.25C11.6646 9.375 12 9.03961 12 8.625C12 8.21039 11.6648 7.875 11.25 7.875Z" fill="#8C67EF"/>
              </svg>
              <p class="base1Text heavy topBottomHalfMargin fontSizeThreeQuarters inlineBlockDisplay">
                Swap
              </p>
            </div>
          </Flex>
          <Flex class="crossAxisCenter">
            <Flex class="mainAxisCenter pointer" @click="removeHolding(index)">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.5714 1.875H9.36482L8.45411 0.544922C8.19911 0.206883 7.80536 0 7.35536 0H4.64464C4.19464 0 3.77679 0.206883 3.54643 0.544922L2.63518 1.875H0.428571C0.190848 1.875 0 2.04211 0 2.25V2.625C0 2.83359 0.190848 3 0.428571 3H0.857143V10.5C0.857143 11.3285 1.62455 12 2.57143 12H9.42857C10.3754 12 11.1429 11.3285 11.1429 10.5V3H11.5714C11.8098 3 12 2.83359 12 2.625V2.25C12 2.04211 11.8098 1.875 11.5714 1.875ZM4.60446 1.1925C4.63125 1.15148 4.68482 1.125 4.74107 1.125H7.25893C7.31585 1.125 7.36942 1.15137 7.39621 1.19238L7.86429 1.875H4.13571L4.60446 1.1925ZM9.42857 10.875H2.57143C2.33472 10.875 2.14286 10.7071 2.14286 10.5V3H9.85714V10.5C9.85714 10.7063 9.66429 10.875 9.42857 10.875ZM6 9.75C6.23689 9.75 6.42857 9.58228 6.42857 9.375V4.5C6.42857 4.29272 6.23689 4.125 6 4.125C5.76311 4.125 5.57143 4.29375 5.57143 4.5V9.375C5.57143 9.58125 5.76429 9.75 6 9.75ZM3.85714 9.75C4.09286 9.75 4.28571 9.58125 4.28571 9.375V4.5C4.28571 4.29272 4.09404 4.125 3.85714 4.125C3.62025 4.125 3.42857 4.29375 3.42857 4.5V9.375C3.42857 9.58125 3.62143 9.75 3.85714 9.75ZM8.14286 9.75C8.37975 9.75 8.57143 9.58228 8.57143 9.375V4.5C8.57143 4.29272 8.37975 4.125 8.14286 4.125C7.90596 4.125 7.71429 4.29375 7.71429 4.5V9.375C7.71429 9.58125 7.90714 9.75 8.14286 9.75Z" fill="#969EB0"/>
              </svg>
            </Flex>
              <b-tooltip
                label="Unlock weight"
                v-if="holding.locked"
              >
                <Flex
                  class="mainAxisCenter pointer rightMargin"
                  @click="holding.locked = false"
                >
                  <svg width="12" height="12" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18.5 10.4578L17.75 10.5V6.75C17.75 3.02766 14.7223 0 11 0C7.27766 0 4.25 3.02766 4.25 6.75V10.5L3.5 10.4578C1.84297 10.4578 0.5 11.8008 0.5 13.4578V20.9578C0.5 22.6144 1.84297 23.9578 3.5 23.9578H18.5C20.157 23.9578 21.5 22.6144 21.5 20.9578V13.4578C21.5 11.8453 20.1547 10.4578 18.5 10.4578ZM7.25 6.75C7.25 4.68188 8.93281 3 11 3C13.0672 3 14.75 4.68188 14.75 6.75V10.5H7.25V6.75Z" fill="#969EB0"/>
                  </svg>
                </Flex>
              </b-tooltip>
              <b-tooltip
                label="Lock weight to prevent auto adjustment"
                v-if="!holding.locked"
              >
                <Flex
                  class="mainAxisCenter pointer rightMargin"
                  @click="holding.locked = true"
                >
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_518_2596)">
                      <path d="M9.3 0.0164888C7.51042 -0.179615 6 1.40274 6 3.37501V5.25001H1.33333C0.596875 5.25001 0 5.92267 0 6.75001V10.5C0 11.3283 0.596875 12 1.33333 12H8C8.73646 12 9.33333 11.3283 9.33333 10.5V6.75001C9.33333 5.92149 8.73646 5.25001 8 5.25001H7.33333V3.37501C7.33333 2.27603 8.1775 1.39548 9.17438 1.51009C10.0229 1.6097 10.6667 2.50548 10.6667 3.48517V4.87501C10.6667 5.08126 10.8167 5.25001 11 5.25001H11.6667C11.85 5.25001 12 5.08126 12 4.87501V3.52501C12 1.76345 10.8583 0.187322 9.3 0.0164888Z" fill="#969EB0"/>
                    </g>
                    <defs>
                      <clipPath id="clip0_518_2596">
                        <rect width="12" height="12" fill="white"/>
                      </clipPath>
                    </defs>
                  </svg>
                </Flex>
              </b-tooltip>
            <Flex class="flex2">
              <b-input
                size="is-small"
                type="number"
                label="Weight"
                v-bind:value="holding.percentage"
                v-bind:disabled="holding.locked || portfolio.holdings.length === 1"
                v-bind:min="0"
                v-bind:max="100"
                v-on:blur="adjustPercentages(holding, $event)"
              />
            </Flex>
          </Flex>
        </Flex>
        <div class="topMargin">
          <div class="bottomMargin25Px" v-for="(value, key) in chartData2(screenedHoldingsById[holding.id])" :key="key">
            <div :class="`fontSizeHalf ${value.label === 'Overall Alignment' ? 'extraBold' : 'heavy'}`">{{value.label}}</div>
            <div class="relativePosition">
              <div class="height20Px fullWidth absolutePosition slightCurvedBorder" :style="{ backgroundColor: '#eeeff2' }" />
              <div
                class="height20Px lineHeight17Px fontSizeHalf leftPaddingHalf bold width150Px base1 absolutePosition leftSlightCurvedBorder"
                :style="{
                  width: `${value.score * 10}%`,
                  backgroundColor: value.color,
                  borderRadius: value.score > '9.8' ? '5px' : '',
                  color: textColorScale()(value.score),
                }"
              >{{Number(value.score).toFixed()}}</div>
            </div>
          </div>
        </div>
      </Flex>
    </div>
  </div>
</template>

<script>
import chroma from 'chroma-js';
import _ from 'lodash';

import ValuesChart from '@frontend/dash3/js/components/fundscreener/ValuesChart.js';
import Holding from '@frontend/dash3/js/components/fundscreener/Holding.vue';
import TypeaheadPortfolioSearch from '@frontend/dash3/js/components/portfolios/TypeaheadPortfolioSearch.vue';
import IRebalSync from '@frontend/dash3/js/components/integrations/irebal/IRebalSync.vue';
import Flex from '@frontend/components/Flex.vue';
import Backtester from '@frontend/builder/js/components/Backtester.vue';

import eventBus from '@frontend/shared/EventBus.js';
import { preciseRound } from '@frontend/shared/Util.js';

export default {
  data() {
    return {
      portfolio: {
        name: 'Untitled Portfolio',
        holdings: [],
        screenedHoldings: [],
        apiObject: null,

        destination: {
          id: null,
          status: 'd',
        },
        holdingPercentages: {},
      },
      saving: null,
      edited: false,

      exchangeTarget: null,

      weightsManuallyAdjusted: false,

      holdingsSort: {
        key: null,
        dir: 'asc',
      },
    };
  },
  components: {
    TypeaheadPortfolioSearch,
    ValuesChart,
    Holding,
    IRebalSync,
    Flex,
    Backtester,
  },
  props: {
    values: {
      type: Object,
      default() {
        return {
          a: [],
          byId: {},
        };
      },
    },
    screens: {
      type: Object,
      default() {
        return {
          a: [],
          byId: {},
        };
      },
    },
    funds: {
      type: Boolean,
      default: false,
    },
    companies: {
      type: Boolean,
      default: false,
    },
    chartValueRange: {
      type: Array,
      default() {
        return [0, 10];
      },
    },
  },
  methods: {
    textColorScale() {
      return chroma.scale(['#DD3C57', '#FFFFFF', '#FBD7D0', '#F6DBD5', '#C2861E', '#C8A91E', '#868E57', '#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF']).domain([0, 10]);
    },
    aggregateScore: function(column) {
      const holdingPcts = this.holdingPercentagesById;
      const weightedScores = this.portfolio.screenedHoldings.map((itm) => {
        return itm[column] * (holdingPcts[itm.ticker__id]);
      });
      if (weightedScores.length > 0) {
        return weightedScores.reduce((a, b) => {
          return a + b;
        }) / this.portfolio.screenedHoldings.reduce((a, b) => {
          return a + holdingPcts[b.ticker__id];
        }, 0);
      }
      return '';
    },
    clear: function() {
      this.saving = null;
      this.portfolio.name = 'Untitled Portfolio';
      this.portfolio.holdings = [];
      this.portfolio.screenedHoldings = [];
      this.portfolio.apiObject = null;
      this.portfolio.destination.id = null;
      this.portfolio.destination.status = 'd';
      this.portfolio.holdingPercentages = {};
      this.portfolio.originalId = null;
      this.portfolio.originalValue = null;
      this.weightsManuallyAdjusted = false;
      this.exchangeTarget = null;
      this.edited = false;
      setTimeout(() => {
        eventBus.$emit('FundScreener:exchange-holding', null);
      }, 10);
    },
    preciseRound: function(val, dig) {
      return preciseRound(val, dig);
    },
    doSave: async function(name) {
      this.saving = true;
      if (this.portfolio.destination.status === 'd' && !this.edited) {
        this.edited = true;
        this.portfolio.name = this.portfolio.name + ' (Draft Copy)';
      }
      console.log('[WorkingPortfolio] Save initiated.');
      const url = this.portfolio.destination.id ? `/api/v1/portfolios/${this.portfolio.destination.id}/` : '/api/v1/portfolios/';
      const req = await fetch(url, {
        method: this.portfolio.destination.id ? 'PUT' : 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': this.$root.$data.csrfToken,
        },
        body: JSON.stringify({
          'name': name || this.portfolio.name,
          'status': this.portfolio.destination.status,
          'total_value': this.portfolio.originalValue ? this.portfolio.originalValue : 1000000,
          'holdings': this.portfolio.holdings.map((itm) => {
            return {
              'identifier': itm.id,
              'identifier_type': 'ticker_id',
              'percentage': itm.percentage / 100,
            };
          }),
        }),
      });
      if (req.ok) {
        const data = await req.json();
        console.log('Saved portfolio');
        if (name) {
          this.portfolio.name = name;
        }
        this.portfolio.destination.id = data.id;
        this.saving = false;
        return data;
      } else {
        console.log('Error saving portfolio');
      }
    },
    removeHolding: function(index) {
      const id = this.portfolio.holdings[index].id;
      // We are managing holdings in two places because the fund screener doesn't necesarily return everything
      // that makes up a portfolio, so if you are editing a mixed portfolio we want to ensure that you don't save a
      // copy missing the holdings that aren't returned by the fund screener.
      // This dance in particular is necessary because the lists may not be sorted the same way, so we delete directly
      // by index from the list used in rendering the list of holdings, while searching the other list before deleting.
      for (let i = 0; i < this.portfolio.screenedHoldings.length; i++) {
        if (this.portfolio.screenedHoldings[i].ticker.id === id) {
          this.portfolio.screenedHoldings.splice(i, 1);
          break;
        }
      }
      this.adjustPercentages(this.portfolio.holdings[index], { target: { value: 0 } });
      this.portfolio.holdings.splice(index, 1);
      this.doSave();
    },
    savePortfolio: async function() {
      this.$buefy.dialog.prompt({
        message: 'Save this portfolio as:',
        inputAttrs: {
          placeholder: this.portfolio.name,
          maxlength: 200,
          value: this.portfolio.name,
        },
        trapFocus: true,
        closeOnConfirm: false,
        confirmText: 'Save',
        onConfirm: async (value, { close }) => {
          this.$buefy.toast.open(`Saving as: ${value}...`);
          this.portfolio.destination.status = 'a';
          this.portfolio.destination.id = null;
          const result = await this.doSave(value);
          eventBus.$emit('FundScreener:working-portfolio-selected', { name: this.portfolio.name });
          close();
        },
      });
    },
    showDetail: function(holding, event) {
      event.preventDefault();
      eventBus.$emit('FundScreener:show-detail', this.screenedHoldingsById[holding.id]);
    },
    holdingClass: function(holding) {
      const classes = ['holding-row'];
      if (this.exchangeTarget && holding.id === this.exchangeTarget.id) {
        classes.push('exchange-target');
      }
      if (!(holding.id in this.screenedHoldingsById)) {
        classes.push('not-applicable');
      }
      return classes.join(' ');
    },
    applyScreens: async function(firstLoad) {
      this.portfolio.screenedHoldings = [];

      if (this.companies) {
        this.isLoading = true;
        const thresholds = {};
        for (const i in this.screens.a) {
          const thisScreen = this.screens.a[i];
          if (thisScreen.userPercentile && thisScreen.userPercentile > 0) {
            thresholds[`m_${thisScreen.id}`] = thisScreen.userPercentile / 100;
          }
        }
        if (Object.keys(thresholds).length === 0) {
          this.isLoading = false;
          this.excludedCount = 0;
          this.includedCount = 0;
          return;
        }
        const params = new URLSearchParams(thresholds);

        fetch(`/api/v1/impact_factors/screen/model_portfolio/${this.portfolio.originalId}/?${params}`)
            .then((data) => {
              return data.json();
            })
            .then((data) => {
              this.results = data.results;
              this.portfolio.screenedHoldings.push(...data.results);
            });
      }

      if (this.funds) {
        const params = new URLSearchParams({
          values: this.values.a.map((itm) => {
            return itm.id;
          }).join(','),
          in_fund_ids: this.portfolio.holdings
              .filter((itm) => {
                return itm.asset_type === 'ETF' || itm.asset_type === 'Mutual Fund';
              })
              .map((itm) => {
                return itm.id;
              }).join(','),
          per_page: 99999,
          fund_types: '__ALL__',
        });
        const fundsResponse = await fetch(`/api/v1/explore/funds/?${params}`);
        const fundsData = await fundsResponse.json();
        this.portfolio.screenedHoldings.push(...fundsData.funds);
      }
      if (firstLoad) {
        this.portfolio.holdings.sort((a, b) => {
          if ((a.id in this.screenedHoldingsById) && (b.id in this.screenedHoldingsById)) {
            return b.percentage - a.percentage;
          }
          if (a.id in this.screenedHoldingsById) {
            return -1;
          }
          return 1;
        });
      }
    },
    portfolioSelectedCallback: async function(option) {
      this.weightsManuallyAdjusted = true;
      this.portfolio.destination.id = null;
      this.portfolio.name = option.name;
      this.portfolio.originalId = option.id;
      if (this.portfolio.holdings.length > 0) {
        this.portfolio.holdings = [];
      }
      const response = await fetch(`/api/v1/portfolios/${option.id}/?holdings=true`);
      const data = await response.json();

      const totalValue = data.portfolio.holdings.reduce((acc, itm) => {
        return acc + itm.dollars;
      }, 0);

      this.portfolio.originalValue = totalValue;

      data.portfolio.holdings.forEach((itm) => {
        itm.ticker.locked = false;
        itm.ticker.percentage = preciseRound((itm.dollars / totalValue) * 100, 2);
      });

      const fundAssetTypes = { 'ETF': true, 'Mutual Fund': true };
      this.portfolio.holdings.push(
          ...data.portfolio.holdings
              .map((itm) => {
                return itm.ticker;
              }),
      );

      this.portfolio.apiObject = data.portfolio;

      eventBus.$emit('FundScreener:working-portfolio-selected', { name: this.portfolio.name });
      this.applyScreens(true);
    },
    exchangeHolding: function(holding) {
      if (this.exchangeTarget && holding.id === this.exchangeTarget.id) {
        this.exchangeTarget = null;
        setTimeout(() => {
          eventBus.$emit('FundScreener:exchange-holding', null);
          eventBus.$emit('CompanyScreener:exchange-holding', null);
        }, 10);
      } else {
        this.exchangeTarget = holding;
        // Use screenedHoldingsById if available, otherwise create a minimal object from holding
        const holdingData = this.screenedHoldingsById[holding.id] || {
          ticker__id: holding.id,
          ticker__symbol: holding.symbol,
          ticker__full_name: holding.full_name,
          ticker__benchmark_description: holding.benchmark_description,
          ticker__asset_type: holding.asset_type,
          ticker__expense_ratio: holding.expense_ratio,
          ticker__total_value: holding.total_value,
          ticker__esg_mandate: holding.esg_mandate
        };
        eventBus.$emit('FundScreener:exchange-holding', holdingData);
        eventBus.$emit('CompanyScreener:exchange-holding', {
          metrics: holdingData,
          holding: holding,
        });
      }
    },
    colorScale: function() {
      return chroma.scale(['#49040F', '#DE2131', '#C83A1E', '#DE7021', '#F4DEB8', '#F5EABA', '#E4E9C6', '#C4E37D', '#A7D572', '#8AC468', '#3FA25C']).domain(this.chartValueRange);
    },
    sumPct: function() {
      return this.portfolio.holdings.reduce((a, b) => {
        return a + b.percentage;
      }, 0);
    },
    adjustPercentages: function(changedHolding, event) {
      const newNumber = Number(event.target.value);
      this.weightsManuallyAdjusted = true;
      if (newNumber + this.lockedTotal > 100) {
        // Unable to resolve a case where the changed slider + all locked sliders add up to more than 100, so we set
        // the slider
        changedHolding.percentage = 100 - this.lockedTotal;
      } else {
        changedHolding.percentage = newNumber;
      }

      let difference = preciseRound(100 - this.sumPct(), 2);
      let iter = 0;
      let factor = difference;
      while (Math.abs(difference, 2) > 0 && Math.abs(factor) > 0 && iter < 20) {
        // Very simply redistribute the percentage points that we're over/under 100 after applying the slider change.
        // We just evenly spread the difference out until it is negligible. This is non optimal since some values will
        // go to zero along the way, so instead of getting fance we just make a few passes. 20 pass limit in case of
        // unexpected values so we don't lock up the browser with an inifinite loop.
        iter++;

        // TODO: Slightly weird behavior with numbers around 0/100 introduced by rounding

        console.log(`Iteration #${iter}, diff=${difference}`);
        const holdingsToChange = this.portfolio.holdings.filter((itm) => {
          return itm.id !== changedHolding.id && !itm.locked;
        });

        factor = preciseRound(difference / holdingsToChange.length, 2);
        holdingsToChange.forEach((itm) => {
          const newPct = preciseRound(itm.percentage + factor, 2);
          if (newPct <= 100 && newPct >= 0) {
            itm.percentage = preciseRound(newPct, 2);
          }
        });
        difference = preciseRound(100 - this.sumPct(), 2);
      }

      this.debouncedSave();
    },
    chartClick: function(evt, target, chart) {
      if (target.length > 0 && target[0].index >= 0) {
        const sortKey = chart.data.sortKeys[target[0].index];
        if (this.holdingsSort.key === sortKey) {
          this.holdingsSort.dir = this.holdingsSort.dir === 'asc' ? 'desc' : 'asc';
        } else {
          this.holdingsSort.dir = 'asc';
        }
        this.holdingsSort.key = sortKey;
        this.portfolio.holdings.sort((a, b) => {
          if ((a.id in this.screenedHoldingsById) && (b.id in this.screenedHoldingsById)) {
            const aVal = this.screenedHoldingsById[b.id][sortKey];
            const bVal = this.screenedHoldingsById[a.id][sortKey];
            return this.holdingsSort.dir === 'asc' ? aVal - bVal : bVal - aVal;
          }
          if (a.id in this.screenedHoldingsById) {
            return -1;
          }
          return 1;
        });
      }
    },
    chartData2(holding) {
      if (!this.portfolio.holdings.length) {
        return {};
      }

      // When no values are selected, don't show overall alignment
      if (this.values.a.length === 0) {
        return {};
      }

      let overallScore;
      if (holding) {
        overallScore = holding.composite;
      } else {
        overallScore = this.usingPercentiles ? this.aggregateScore('composite') * 100 : this.aggregateScore('composite');
      }
      const overallData = {
        overall: {
          score: preciseRound(overallScore, 1),
          label: this.usingPercentiles ? 'Average Percentile': 'Overall Alignment',
          color: this.colorScale()(overallScore).hex(),
        },
      };
      const chartData = this.values.a.reduce((acc, value) => {
        const score = holding ? holding[`composite_values_${value.id}`] : this.aggregateScore(`composite_values_${value.id}`);
        return {
          [value.id]: {
            score,
            label: value.name,
            color: this.colorScale()(score).hex(),
          },
          ...acc,
        };
      }, overallData);
      return chartData;
    },
  },
  computed: {
    usingPercentiles: function() {
      return this.screens.a.length > 0;
    },
    holdingPercentagesById: function() {
      return this.portfolio.holdings
          .reduce((acc, itm) => {
            acc[itm.id] = itm.percentage;
            return acc;
          }, {});
    },
    screenedHoldingsById: function() {
      return this.portfolio.screenedHoldings.reduce((acc, itm) => {
        acc[itm.ticker__id] = itm;
        return acc;
      }, {});
    },
    lockedTotal: function() {
      return this.portfolio.holdings.filter((itm) => {
        return itm.locked;
      }).reduce((a, b) => {
        return a + b.percentage;
      }, 0);
    },
    hasWorkingPortfolio: function() {
      return this.portfolio.apiObject || this.portfolio.destination.id;
    },
    chartOptions: function() {
      return {
        onClick: this.chartClick,
        plugins: {
          legend: {
            display: false,
          },
        },
        scales: {
          y: {
            grid: {
              display: false,
              drawBorder: false,
              color: 'hotpink',
            },
            display: false,
            min: 0,
            max: this.usingPercentiles ? 100 : 10,
            stepSize: 1,
          },
        },
      };
    },
    chartData: function() {
      let overall = this.aggregateScore('composite');
      console.log('OVERAL', overall);
      if (this.usingPercentiles) {
        overall = overall * 100; // If we're running on screens instead of values, scores are percentelies
      }
      const color = this.colorScale()(overall);
      const overallLabel = this.usingPercentiles ? 'Average Percentile': 'Overall Alignment';
      const data = {
        labels: [overallLabel],
        sortKeys: ['composite'],
        datasets: [
          {
            backgroundColor: [color.hex()],
            hoverBackgroundColor: [color.hex()],
            borderColor: [chroma(color).darken().hex()],
            borderWidth: 1,
            data: [preciseRound(overall, 1)],
          },
        ],
      };
      this.values.a.forEach((itm) => {
        data.labels.push(itm.name);
        data.sortKeys.push(`composite_values_${itm.id}`);
        const score = this.aggregateScore(`composite_values_${itm.id}`);
        const color = this.colorScale()(score).hex();
        data.datasets[0].backgroundColor.push(color);
        data.datasets[0].hoverBackgroundColor.push(color);
        data.datasets[0].borderColor.push(chroma(color).darken().hex());
        data.datasets[0].data.push(preciseRound(score, 1));
      });

      this.screens.a.filter((itm) => {
        return itm.userPercentile > 0;
      }).forEach((itm) => {
        data.labels.push(itm.name);
        data.sortKeys.push(`metric_${itm.id}_percentile`);
        const score = this.aggregateScore(`metric_${itm.id}_percentile`) * 100;
        const color = this.colorScale()(score).hex();
        data.datasets[0].backgroundColor.push(color);
        data.datasets[0].hoverBackgroundColor.push(color);
        data.datasets[0].borderColor.push(chroma(color).darken().hex());
        data.datasets[0].data.push(preciseRound(score, 1));
      });
      console.log('CHART DATA', data);
      return data;
    },
    reportUrl: function() {
      const args = {
        reporting: this.portfolio.destination.id,
        values: this.values.a.map((itm) => itm.id).join(','),
        reportType: 'impact',
        reportStyle: 'minimal_relative',
      };
      if (this.portfolio.originalId) {
        args.benchmark = this.portfolio.originalId;
      }
      return `/ui/advisor/reports/?${new URLSearchParams(args)}`;
    },
  },
  created: function() {
    const self = this;

    self.debouncedSave = _.debounce(this.doSave, 1000);

    eventBus.$on('FundScreener:values-changed', () => {
      if (self.portfolio.holdings.length > 0) {
        this.applyScreens();
      }
    });

    // Clear exchange target when exchange mode is cancelled from main view
    eventBus.$on('FundScreener:exchange-holding', (holding) => {
      if (!holding) {
        self.exchangeTarget = null;
      }
    });

    eventBus.$on('CompanyScreener:add-holding-to-portfolio', (holdings, mode) => {
      const holdingsCopy = JSON.parse(JSON.stringify(holdings));
      const knownIds = this.portfolio.holdings.reduce((acc, itm) => {
        acc[itm.id] = true; return acc;
      }, {});
      const dedupedFunds = holdingsCopy.filter((itm) => {
        return !(itm.ticker__id in knownIds);
      });

      if (mode === 'exchange' && !this.exchangeTarget) {
        return;
      }
      const percentage = self.exchangeTarget.percentage;

      dedupedFunds.forEach((itm) => {
        itm.ticker = {
          id: itm.ticker__id,
          full_name: itm.ticker__full_name,
          symbol: itm.ticker__symbol,
          benchmark_description: itm.ticker__benchmark_description,
          expense_ratio: itm.ticker__expense_ratio,
          total_value: itm.ticker__total_value,
          esg_mandate: itm.ticker__esg_mandate,
          percentage: percentage,
          locked: false,
        };
      });

      if (dedupedFunds.length === 0) {
        // this.$buefy.dialog.alert(
        //   `${holdingsCopy[0].symbol} is already in this portfolio, please select a different company`
        // );
        self.exchangeTarget = null;
        return;
      }
      const spliceIndex = self.portfolio.holdings.map((itm) => {
        return itm.id;
      }).indexOf(self.exchangeTarget.id);
      if (spliceIndex !== -1) {
        self.portfolio.holdings.splice(
            spliceIndex,
            1,
            dedupedFunds[0].ticker,
        );
        self.portfolio.screenedHoldings.splice(
            self.portfolio.screenedHoldings.map((itm) => {
              return itm.ticker__id;
            }).indexOf(self.exchangeTarget.id),
            1,
            dedupedFunds[0],
        );
      }
      self.exchangeTarget = null;
      self.$nextTick(() => {
        self.debouncedSave();
      });
    });

    eventBus.$on('FundScreener:add-funds-to-portfolio', (funds, mode) => {
      const fundsCopy = JSON.parse(JSON.stringify(funds));
      
      // Transform fund screener data structure to match portfolio expectations
      
      fundsCopy.forEach(fund => {
        
        
        
        
        
        if (fund.ticker__id && (typeof fund.ticker !== 'object' || fund.ticker === null)) {
          
          // Transform from flattened structure (ticker__property) to nested structure (ticker.property)
          fund.ticker = {
            id: fund.ticker__id,
            symbol: fund.ticker__symbol,
            full_name: fund.ticker__full_name,
            benchmark_description: fund.ticker__benchmark_description,
            expense_ratio: fund.ticker__expense_ratio,
            total_value: fund.ticker__total_value,
            esg_mandate: fund.ticker__esg_mandate
          };
          
          // Preserve composite and values data 
          if (fund.composite !== undefined) {
            fund.ticker.composite = fund.composite;
          }
          
          // Preserve individual composite_values scores
          Object.keys(fund).forEach(key => {
            if (key.startsWith('composite_values_')) {
              fund.ticker[key] = fund[key];
            }
          });
          console.log('After transformation:', fund);
        } else if (fund.ticker) {
          console.log('Fund already has ticker:', fund.ticker, 'Type:', typeof fund.ticker);
        } else {
          console.log('Fund missing ticker__id:', fund);
        }
      });
      console.log('After transformation:', fundsCopy);
      const knownIds = this.portfolio.holdings.reduce((acc, itm) => {
        acc[itm.id] = true; return acc;
      }, {});
      const dedupedFunds = fundsCopy.filter((itm) => {
        return !(itm.ticker.id in knownIds);
      });

      if (mode === 'exchange' && !this.exchangeTarget) {
        return;
      }

      let percentage = 0;
      if (mode === 'exchange') {
        percentage = self.exchangeTarget.percentage;
      } else {
        if (this.portfolio.holdings.length === 0) {
          percentage = 100 / dedupedFunds.length;
        } else if (!this.weightsManuallyAdjusted) {
          percentage = 100 / (this.portfolio.holdings.length + dedupedFunds.length);
          this.portfolio.holdings.forEach((itm) => {
            itm.percentage = percentage;
          });
        }
      }
      dedupedFunds.forEach((itm) => {
        console.log('About to set percentage on:', itm);
        console.log('Ticker:', itm.ticker);
        console.log('Ticker type:', typeof itm.ticker);
        console.log('Is ticker a string?:', typeof itm.ticker === 'string');
        if (typeof itm.ticker === 'string') {
          console.error('ERROR: Ticker is still a string!', itm.ticker);
          console.log('Full fund object:', itm);
        }
        itm.ticker.percentage = percentage;
        itm.ticker.locked = false;
      });
      if (dedupedFunds.length === 0) {
        // this.$buefy.dialog.alert(
        //   `${funds[0].ticker.symbol} is already in this portfolio, please select a different company`
        // );
        self.exchangeTarget = null;
        setTimeout(() => {
          eventBus.$emit('FundScreener:exchange-holding', null);
          eventBus.$emit('CompanyScreener:exchange-holding', null);
        }, 10);
        return;
      }
      if (mode === 'exchange') {
        const spliceIndex = self.portfolio.holdings.map((itm) => {
          return itm.id;
        }).indexOf(self.exchangeTarget.id);
        if (spliceIndex !== -1) {
          self.portfolio.holdings.splice(
              spliceIndex,
              1,
              dedupedFunds[0].ticker,
          );
          self.portfolio.screenedHoldings.splice(
              self.portfolio.screenedHoldings.map((itm) => {
                return itm.ticker.id;
              }).indexOf(self.exchangeTarget.id),
              1,
              dedupedFunds[0],
          );
        }
        self.exchangeTarget = null;
        setTimeout(() => {
          eventBus.$emit('FundScreener:exchange-holding', null);
          eventBus.$emit('CompanyScreener:exchange-holding', null);
        }, 10);
      } else {
        self.portfolio.holdings.unshift(...dedupedFunds.map((itm) => {
          return itm.ticker;
        }));
        self.portfolio.screenedHoldings.push(...dedupedFunds);
      }
      self.$nextTick(() => {
        self.debouncedSave();
      });
    });
  },
};
</script>

<style lang="scss">
.working-portfolio {
  min-height: 400px;
}

.not-applicable {
  opacity: 0.5;
}

.holdings {
  .holding-controls {
    min-width: 50px;
    justify-content: left;
  }

  .holding-row {
    padding: 1rem;
  }

  .holding-row:nth-child(even) {
    background-color: #fbfbfb;
  }

  .holding-row.exchange-target {
    border-left: 5px solid hotpink;
  }

  .overall-contribution {
    text-align: center;
  }
}

</style>
